import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "./api";
import { Loading } from "@/components/Bits";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [unread, setUnread] = useState(0);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user); setUnread(data.unread);
    } catch {
      try { await api.post("/auth/refresh"); const { data } = await api.get("/auth/me"); setUser(data.user); setUnread(data.unread); }
      catch { setUser(false); }
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setUser(false); };
  const setMode = async (mode) => { const { data } = await api.put("/me/mode", { mode }); setUser(data.user); };
  return <Ctx.Provider value={{ user, setUser, refresh, logout, setMode, unread }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
export const hasRole = (u, r) => !!u && (u.roles || []).some((x) => x === r || (r === "admin" && x === "super_admin"));

export function Protected({ children, role }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (role && !hasRole(user, role)) return <Navigate to="/dashboard" replace />;
  return children;
}
